module.exports = __webpack_public_path__ + "img/AI.9ab72c85.png";